<template>
  <div>
    <div class="d-inline-flex mb-4">
      <h4 class="mr-3 mb-0">Light </h4>
    </div>
    <div class="mb-5">
      <div class="fields-wrapper is-divider mb-3">
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Select light
              </label>
              <div class="col-sm-8">
                <select class="custom-select" v-model="activeLight.lightType" @change="lightTypeChanged">
                  <option value="point">Point Light</option>
                  <option value="spot">Spot Light</option>
                  <option value="directional">Directional Light</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-4 col-form-label">
                Start Time
              </label>
              <div class="col-sm-8">
                <input type="number" class="form-control" id="start_time" v-model="activeLight.startTime" @change="setDuration(index)">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-4 col-form-label">
                End Time
              </label>
              <div class="col-sm-8">
                <input type="number" class="form-control" id="end_time" v-model="activeLight.endTime" @change="setDuration(index)">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Duration
              </label>
              <div class="col-sm-8">
                <input 
                  type="number" 
                  :value="(activeLight.endTime - activeLight.startTime).toFixed(2)" 
                  class="form-control" 
                  id="animation_duration_e"
                  readonly
                >
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" for="range">
                Range
              </label>
              <div class="col-sm-8">
                <input type="number" class="form-control" id="range" v-model="activeLight.range">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" for="exposure">
                Exposure
              </label>
              <div class="col-sm-8">
                <input type="range"  min="0" max="2" v-model="activeLight.exposure" />
                <span class="ml-3">{{ activeLight.exposure }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center" v-if="activeLight.lightType == 'spot'">
              <label class="col-sm-4 col-form-label" for="spotAngle">
                Spot Angle
              </label>
             <div class="col-sm-8">
                <div class="d-flex align-items-center">
                  <span class="p-2">Inner</span>
                  <input type="number" min='0' max='360' class="form-control" id="innerangle" v-model="activeLight.innerSpotAngle">
                  <span class="p-2">Outer</span>
                  <input type="number" min='0' max='360' class="form-control" id="outerangle" v-model="activeLight.outerSpotAngle">
                </div>  
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" id="color">
                Color
              </label>
              <div class="col-sm-8">
                <input type="color" id="favcolor" name="favcolor" v-model="activeLight.color">

                {{ activeLight.color }}

              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Shadow Type
              </label>
              <div class="col-sm-8">
                <select class="custom-select" v-model="activeLight.shadowType">
                  <option value="Soft">Soft</option>
                  <option value="Hard">Hard</option>
                  <option value="None">None</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Shadow Strength
              </label>
              <div class="col-sm-8">
                <input type="range"  min="0" max="1" step="0.1" v-model="activeLight.shadowStrength" />
                <span class="ml-3">{{ activeLight.shadowStrength }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label" for="mode">
                Mode
              </label>
              <div class="col-sm-8">
                <select class="custom-select" v-model="activeLight.lightMode">
                  <option value="Realtime">Realtime</option>
                </select>
              </div>
            </div>
             <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Position of the origin
              </label>
              <div class="col-sm-8">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="number" class="form-control border-danger" id="position_of_the_origin_x" v-model="activeLight.localPosition[0]">
                  <span class="p-2">y</span>
                  <input type="number" class="form-control border-success" id="position_of_the_origin_y" v-model="activeLight.localPosition[1]">
                  <span class="p-2">z</span>
                  <input type="number" class="form-control border-secondary" id="position_of_the_origin_z" v-model="activeLight.localPosition[2]">

                </div>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Rotation of the origin
              </label>
              <div class="col-sm-8">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="number" class="form-control border-danger" id="rotation_of_the_origin_x" v-model="activeLight.localRotation[0]">
                  <span class="p-2">y</span>
                  <input type="number" class="form-control border-success" id="rotation_of_the_origin_y" v-model="activeLight.localRotation[1]">
                  <span class="p-2">z</span>
                  <input type="number" class="form-control border-secondary" id="rotation_of_the_origin_z" v-model="activeLight.localRotation[2]">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {uuid} from 'vue-uuid'
import { mapState } from 'vuex'

export default {
  components: {},
  data () {
    return {
      activeLight: [],
      activeChar: {},
      objectId: '',
    }
  },
  created () {
    this.getActiveLight()
  },

  methods: { 
    lightTypeChanged() {
      if(this.activeLight.lightType != 'spot') {
        delete this.activeLight.innerSpotAngle;
        delete this.activeLight.outerSpotAngle;
      } else {
        this.activeLight.innerSpotAngle = 0
        this.activeLight.outerSpotAngle = 0
      }
    },
    getActiveLight() {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeLight = char
          found = true
        }
      }
      if (!found) {
        this.activeLight = this.characters[0]
      }
    },
  },
  mounted () {
  },
  watch: {
    characters (val) {
      this.getActiveLight()
    },
  },
  computed: {
    ...mapState([
      'characters',
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/lights/maininspector.vue